import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'kt-photo-modal',
  templateUrl: './photo-modal.component.html',
  styleUrls: ['./photo-modal.component.scss']
})
export class PhotoModalComponent implements OnInit {

  @Input()
  photoUrl : string;

  @Input()
  title : string ;

  @Input()
  subTitle : string ;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
